import $ from 'jquery';

import { store } from '../redux/store'
import { setSubmenu1Slug, setSubmenu2Slug } from '../redux/main-submenu-slice';

let jqWrapper;
let jqSubmenus;
let jqSubmenus1;
let jqSubmenus2;
let jqSubmenu;
let jqButtonClose;

let submenu1Slug = '';
let submenu2Slug = '';

function init ()
{
    jqWrapper = $('.partial-main-header-submenu')
    jqSubmenus = jqWrapper.find('.main-submenu')
    jqSubmenus1 = jqWrapper.find('.main-submenu-1')
    jqSubmenus2 = jqWrapper.find('.main-submenu-2')
    jqButtonClose = jqWrapper.find('.submenu-close')
    jqWrapper.find('a').on('click', function (event) {
        event.stopPropagation()
    })
    jqSubmenus1.find('li').each(function () {
        const jqLi = $(this)
        const jqA = jqLi.find('a')
        const slug = jqLi.data('slug')
        const hasChildren = jqLi.hasClass('has-children')
        if (slug && hasChildren) {
            jqA.on('click', function (event) {
                event.stopPropagation()
                event.preventDefault()
                store.dispatch(setSubmenu2Slug(slug))
            })
        }
    });
    jqButtonClose.on('click', function (event) {
        event.stopPropagation()
        store.dispatch(setSubmenu1Slug(''))
    });
    jqWrapper.on('click', function (event) {
        event.stopPropagation()
        store.dispatch(setSubmenu1Slug(''))
    })
    store.subscribe(() => {
        const state = store.getState().mainSubmenu
        const newSubmenu1Slug = state.submenu1Slug
        const newSubmenu2Slug = state.submenu2Slug
        if (submenu1Slug != newSubmenu1Slug) {
            submenu1Slug = newSubmenu1Slug
            showSubmenu1(submenu1Slug)
        }
        if (submenu2Slug != newSubmenu2Slug) {
            submenu2Slug = newSubmenu2Slug;
            console.log(submenu2Slug)
            showSubmenu2(submenu2Slug)
        }
    })
}

function showSubmenu1 (submenu1Slug = '')
{
    jqSubmenu = jqWrapper.find(`[data-parent-slug="${submenu1Slug}"]`)
    if (jqSubmenu.length > 0)
    {
        jqWrapper.slideDown()
        jqSubmenus.hide()
        jqSubmenu.show()
        return true;
    } else {
        jqWrapper.slideUp(undefined, () => {
            jqSubmenus.hide()
        })
        return false
    }
}

function showSubmenu2 (submenu2Slug = '')
{
    if (jqSubmenu && jqSubmenu.length > 0 && submenu2Slug)
    {
        const jqSubmenu2 = jqSubmenu.find(`[data-parent-slug="${submenu2Slug}"]`)
        const jqSubmenu2BgImage = jqSubmenu2.find('.bg-image')
        const submenu2BgImageTag = jqSubmenu2.data('bg-image-tag') 
        const jqSubmenuItems = jqSubmenu.find(`[data-slug]`)
        const jqSubmenuActiveItem = jqSubmenu.find(`[data-slug="${submenu2Slug}"]`)
        jqSubmenus2.removeClass('active')
        jqSubmenu2.addClass('active')
        jqSubmenu.addClass('open-submenu-2')
        jqSubmenu2BgImage.html(submenu2BgImageTag)
        jqSubmenuItems.removeClass('active')
        jqSubmenuActiveItem.addClass('active')
        jqSubmenus2.find('a').off('mouseover')
        jqSubmenu2.find('a').on('mouseover', function () {
            const jqA = $(this)
            const jqLi = jqA.parent()
            const bgImageHtml = jqLi.data('bg-image-tag')
            jqSubmenu2BgImage.html(bgImageHtml)
        });
    }
    else
    {
        console.log(jqSubmenus1.length)
        jqSubmenus.removeClass('open-submenu-2')
        jqSubmenus1.find('li').removeClass('active')
        jqSubmenus2.find('a').off('mouseover')
        jqSubmenus2.find('.bg-image').html('')
    }
}

$(() => {
    init();
});
